// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"126":"1b7c321d3d7cb852","149":"e228b70231d35c81","167":"34da85364ab37314","300":"a05e11d2413a99c6","448":"69f8cf5a8a8b534f","791":"11b98fa346bc26a6"}[chunkId] + ".js";
};